import React, { useState } from "react"
import { FORM_NAMES } from "constants/index"
import { connect } from "react-redux"
import { Field, reduxForm, reset } from "redux-form"
import { Col, Row } from "reactstrap"
import { TextField } from "components/RenderInput"
import { SaveButton } from "components/Buttons"
import ModalComponent from "components/Modals"
import CodesFilterModal from "./codesFilterModal"
import { getCodesList } from "store/actions"

const CodesListFilterComponent = ({
  handleSubmit,
  getCodesList,
  resetForm,
}) => {
  const [filterModalIsOpen, setFilterModalIsOpen] = useState(false)
  const [showResetButton, setShowResetButton] = useState(false)

  const searchHandler = data => {
    const searchParams = {
      term: data?.search || "",
      bch: 0,
      o: "created_at",
      od: "desc",
      page: 1,
    }
    let statuses = []
    let types = []
    if (data.unused) {
      statuses.push(0)
    }
    if (data.used) {
      statuses.push(1)
    }
    if (data.pending) {
      statuses.push(2)
    }
    if (data.physical) {
      types.push(0)
    }
    if (data.digital) {
      types.push(1)
    }
    searchParams["statuses"] = statuses
    searchParams["types"] = types
    getCodesList({ ...searchParams })
    setShowResetButton(true)
  }

  const resetSearchHandler = () => {
    getCodesList({ bch: 0, o: "created_at", od: "desc", page: 1 })
    resetForm()
    setShowResetButton(false)
  }

  return (
    <React.Fragment>
      <Row className="d-flex justify-content-center mb-3">
        <Col xs="auto">
          <Field name="search" component={TextField} placeholder="Search" />
        </Col>
        <Col xs="auto">
          <SaveButton
            type="button"
            content="Search"
            onClick={handleSubmit(searchHandler)}
          />
        </Col>
        <Col xs="auto">
          <SaveButton
            type="button"
            content="Filter"
            onClick={() => setFilterModalIsOpen(true)}
          />
        </Col>
        {showResetButton && (
          <Col xs="auto">
            <SaveButton
              type="button"
              content="Reset"
              color="light"
              onClick={resetSearchHandler}
            />
          </Col>
        )}
      </Row>
      <ModalComponent
        title="Filter Codes"
        open={filterModalIsOpen}
        onClose={() => setFilterModalIsOpen(false)}
        size="sm"
      >
        <CodesFilterModal
          searchHandler={handleSubmit(searchHandler)}
          closeHandler={() => setFilterModalIsOpen(false)}
        />
      </ModalComponent>
    </React.Fragment>
  )
}

const mapStateToProps = state => ({})

const mapDispatchToProps = dispatch => ({
  getCodesList: values => dispatch(getCodesList(values)),
  resetForm: () => dispatch(reset(FORM_NAMES.CODES_FILTER)),
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(reduxForm({ form: FORM_NAMES.CODES_FILTER })(CodesListFilterComponent))
